import { useMemo } from 'react';
import { useTheme } from '../styles';

/**
 * Returns a color that is related to the first character on a string
 * @category Formatters
 * @category String
 */
export default function useStringToColor(str) {
  const theme = useTheme();

  // https://www.figma.com/file/WJDRbOCCrGVDTsbUC3yvp8/Luma-Design-System?node-id=1359%3A25499&mode=dev
  const colors = useMemo(() => {
    return [theme.palette.primary.main, theme.palette.primary.main, theme.palette.success.main, theme.palette.success.main, theme.palette.tertiary.main, theme.palette.tertiary.main, theme.palette.info.main, theme.palette.info.main, theme.palette.grey[600], theme.palette.grey[600], theme.palette.primary.main, theme.palette.primary.main, theme.palette.primary.dark, theme.palette.primary.dark, theme.palette.success.dark, theme.palette.success.dark, theme.palette.tertiary.dark, theme.palette.tertiary.dark, theme.palette.info.dark, theme.palette.info.dark, theme.palette.text.secondary, theme.palette.text.secondary, theme.palette.success.dark, theme.palette.success.dark, theme.palette.tertiary.dark, theme.palette.tertiary.dark];
  }, [theme.palette]);
  const firstChar = (str && str.length ? str[0] : '').toLowerCase();
  const indexFromChar = (firstChar.charCodeAt(0) - 97) % colors.length;
  return indexFromChar >= 0 ? colors[indexFromChar] : colors[0];
}